import React from 'react';
import { ORDER_TYPE_DELIVERY } from '../../../constants';
import { formatEstimationTime, getEstimationTime } from '../../../utils';

type OrderStatusEstimationTimeProps = {
  order: any;
};

export default function OrderStatusEstimationTime({
  order,
}: OrderStatusEstimationTimeProps) {
  const { isSchedule, orderType } = order;
  const estimationTime = getEstimationTime(order);
  const { estimationTimeFormat, estimationDayFormat, estimationTimeFormatWithMargin } = formatEstimationTime(estimationTime);
  return (
    <p className='text-left text-gray mb-2 label'>
      {orderType === ORDER_TYPE_DELIVERY
        ? 'Votre livraison'
        : `L'heure de récupération`}{' '}
      est prévue pour :{' '}
      <strong>{`${estimationDayFormat} ${isSchedule ? `à ${estimationTimeFormat}` : estimationTimeFormatWithMargin}`}</strong>
    </p>
  );
}
